export enum ERequestQueryKeys {
  getAllRequests = "getAllRequests",
  addRequest = "addRequest",
  updateRequest = "updateRequest",
}

export const REQUESTS_ENDPOINTS = {
  REQUESTS: "/requests",
};
